import { atom } from "jotai";

export const isVideoModalOpenAtom = atom(false);
